import React from "react";
import { Formik } from "formik";
import {
    TextField,
    withStyles,
    Button,
    Typography,
    MenuItem,
    FormControl,
    InputLabel,
    Select
} from "@material-ui/core";
import { renderToolTip, renderToolTipNamespace } from '../../sc-utilities/accountUtilities'
import * as Yup from "yup";
import { DropzoneArea } from 'material-ui-dropzone'
import { capitalize } from '../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },

    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "120px",
        marginTop: "10px"
    },

    formControl: {
        width: "100%"
    },
    formControlInfo: {
        width: "100%",
        display: 'flex',
        flexDirection: 'row'

    },
    namespace: {
        width: "98%"
    },
    input: {
        display: 'none'
    },
    buttons: {
        textAlign: "right"
    },
    info: {
        position: 'relative',
        marginTop: "38px",
        marginLeft: "15px"
    },
    infoControl: {
        position: 'relative',
        marginTop: "38px",
        marginLeft: "15px"
    },
    imgDiv: {
        width: '100%',
        height: '100%',
        textAlign: 'center',
        justifyContent: 'center'
    },
    img: {
        width: '100%',
        height: '100%',
        maxWidth: window.innerWidth - 100,
        maxHeight: window.innerHeight - 100
    },

    buttonChoose: {
        marginTop: 20,
        width: '100%'
    }
});

const CustomerForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations, handleNext, handleUpload, backValid, backendError, setBackendError } = props;
    let submitAction = ''
    const key = 'customer';
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                enableReinitialize
                onSubmit={async (values, { setSubmitting }) => {

                    if (submitAction === 'finish') {
                        setSubmitting(true);
                        await handleSubmit(values, key);
                        setSubmitting(false);
                    }

                    if (submitAction === 'next') {
                        handleNext(values, key)

                    }

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit, setFieldValue } = formikProps;
                    const onChangeNamespace = (value) => {
                        if (backendError && backendError === "Namespace") {
                            setBackendError(null)
                        }
                        setFieldValue("Namespace", value)
                    }
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="Name"
                                value={values.Name}
                                onChange={handleChange}
                                disabled={backValid[key]}
                                onBlur={handleBlur}
                                error={!!(errors.Name && touched.Name)}
                                placeholder={translations["name"] || "Name"}
                                label={translations["name"] || "Name"}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <FormControl className={classes.formControlInfo} margin={"dense"}>

                                <TextField
                                    name="Namespace"
                                    value={values.Namespace}
                                    onChange={(event) => onChangeNamespace(event.target.value)}
                                    onBlur={handleBlur}
                                    disabled={backValid[key]}
                                    error={!!(errors.Namespace && touched.Namespace) || (backendError && backendError === "Namespace")}
                                    placeholder={translations["namespace"] || "Namespace"}
                                    label={translations["namespace"] || "Namespace"}
                                    margin={"dense"}
                                    className={classes.namespace}
                                />
                                {renderToolTipNamespace(translations, classes.info)}
                            </FormControl>
                            <TextField
                                name="StreetAddress"
                                value={values.StreetAddress}
                                onChange={handleChange}
                                disabled={backValid[key]}
                                onBlur={handleBlur}
                                error={!!(errors.StreetAddress && touched.StreetAddress)}
                                placeholder={translations["street_address"] || "Street address"}
                                label={translations["street_address"] || "Street address"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="PostCode"
                                value={values.PostCode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={backValid[key]}
                                error={!!(errors.PostCode && touched.PostCode)}
                                placeholder={translations["post_code"] || "Post code"}
                                label={translations["post_code"] || "Post code"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="City"
                                value={values.City}
                                onChange={handleChange}
                                disabled={backValid[key]}
                                onBlur={handleBlur}
                                error={!!(errors.City && touched.City)}
                                placeholder={translations["city"] || "City"}
                                label={translations["city"] || "City"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="Country"
                                value={values.Country}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={backValid[key]}
                                error={!!(errors.Country && touched.Country)}
                                placeholder={translations["country"] || "Country"}
                                label={translations["country"] || "Country"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <TextField
                                name="VAT"
                                value={values.VAT}
                                onChange={handleChange}
                                disabled={backValid[key]}
                                onBlur={handleBlur}
                                error={!!(errors.VAT && touched.VAT)}
                                placeholder={translations["country"] || "VAT"}
                                label={translations["country"] || "VAT"}
                                margin={"dense"}
                                fullWidth={true}
                            />

                            <FormControl className={classes.formControlInfo} margin={"dense"}>
                                <InputLabel shrink>{translations['select_password_complexity'] || "Please select password complexity"}</InputLabel>                                <Select
                                    name="PasswordComplexity"
                                    label={translations['password_complexity'] || 'Password complexity'}
                                    margin={"dense"}
                                    disabled={backValid[key]}
                                    className={classes.namespace}
                                    value={values.PasswordComplexity || 'securaze_basic'}
                                    onChange={handleChange}
                                >
                                    <MenuItem key={'securaze_basic'} value={'securaze_basic'}>
                                        {`Securaze ${translations['basic'] || 'basic'}`}
                                    </MenuItem>
                                    <MenuItem key={'securaze_standard'} value={'securaze_standard'}>
                                        {`Securaze ${translations['standard'] || 'standard'}`}
                                    </MenuItem>
                                    <MenuItem key={'microsoft'} value={'microsoft'}>
                                        {`${translations['microsoft'] || 'Microsoft'}`}
                                    </MenuItem>
                                    <MenuItem key={'nist'} value={'nist'}>
                                        {translations['national_institute'] || 'National Institute of Standards and Technology'}
                                    </MenuItem>
                                </Select>
                                {renderToolTip(values.PasswordComplexity, translations, classes.infoControl)}

                            </FormControl>
                            <>
                                <div className={classes.img}>
                                    <DropzoneArea
                                        getFileRemovedMessage={(fileName) => {
                                            const text = translations ? (
                                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['removed'] || 'removed'}.`)
                                            ) : `File ${fileName} removed.`
                    
                                            return text;
                                        }}
                                        getFileAddedMessage={(fileName) => {
                                            const text = translations ? (
                                                capitalize(`${translations['file'] || 'File'} ${fileName} ${translations['successfully_added'] || 'successfully added'}.`)
                                            ) : `File ${fileName} successfully added.`
                    
                                            return text;
                                        }}
                                        getFileLimitExceedMessage={(filesLimit) => {
                                            const text = translations ? (
                                                capitalize(`${translations['maximum_allowed_number'] || 'Maximum allowed number of files exceeded. Only'} ${filesLimit} ${translations['allowed'] || 'allowed'}.`)
                                            ) : `Maximum allowed number of files exceeded. Only ${filesLimit} allowed`
                    
                                            return text;
                                        }}
                                        getDropRejectMessage={(rejectedFile) => {
                                            const text = translations ? (
                                                capitalize(`${translations['File'] || 'File'} ${translations['was_rejected'] || 'was rejected'}.`)
                                            ) : `File was rejected.`
                    
                                            return text;
                                        }}
                                        filesLimit={backValid[key] ? 0 : 1}
                                        maxFileSize={5368709120}
                                        dropzoneText={`${translations['drag_and_drop'] || 'Drag and drop an image file here or click'}`}
                                        onChange={handleUpload}
                                        acceptedFiles={['image/*']}
                                    />

                                </div>
                            </>
                            <div className={classes.buttons}>
                                {formSettings.ButtonNext ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        onClick={() => {
                                            submitAction = 'next';
                                            formikProps.submitForm();
                                        }}
                                        type="submit"
                                        color={formSettings.ButtonNext.Color}
                                        disabled={backValid[key] ? !backValid[key] : false || loading || !(isValid && dirty) || isSubmitting}

                                    >
                                        {formSettings.ButtonNext.Title}
                                    </Button>
                                ) : null
                                }

                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(CustomerForm);
